import DistanceUnits from '../../../../Data/DistanceUnits';

const KM_PER_MILE = 1.60934;
const DISTANCE_DECIMAL_PLACES = 1;

const toKnownUnit = (unit) => {
  if (typeof unit !== 'string') return null;

  const normalisedUnit = unit.trim().toLowerCase();
  return Object.values(DistanceUnits).includes(normalisedUnit)
    ? normalisedUnit
    : null;
};

const convertDistance = ({ distance, fromUnit, toUnit }) => {
  if (fromUnit === toUnit) return distance;
  if (fromUnit === DistanceUnits.KM) return distance / KM_PER_MILE;

  return distance * KM_PER_MILE;
};

/**
 * Restates every store distance in the unit the form builder chose for the
 * store radius, so the radius filter and the distances on screen agree. Applied
 * before filtering, as the radius is expressed in that same unit.
 *
 * Locations are returned untouched when the form configures no unit, and
 * individually untouched when a store's own unit is missing or unrecognised -
 * converting those would mean guessing what the number means.
 */
export const convertLocationDistancesToRadiusUnit = ({
  locations,
  storeRadiusUnit,
}) => {
  const toUnit = toKnownUnit(storeRadiusUnit);
  if (!toUnit) return locations;

  return locations.map((location) => {
    const fromUnit = toKnownUnit(location.distanceUnit);
    if (!fromUnit) return location;
    if (typeof location.distance !== 'number') return location;

    const distance = convertDistance({
      distance: location.distance,
      fromUnit,
      toUnit,
    });

    return {
      ...location,
      distance: Number(distance.toFixed(DISTANCE_DECIMAL_PLACES)),
      distanceUnit: toUnit,
    };
  });
};

/**
 * Keeps only the locations within the client-api component's store_radius.
 * Locations are returned unfiltered when no radius is configured.
 */
export const filterLocationsByRadius = ({ locations, storeRadius }) => {
  if (storeRadius === null || storeRadius === undefined || storeRadius === '') {
    return locations;
  }

  const radius = Number(storeRadius);
  if (!Number.isFinite(radius)) return locations;

  return locations.filter(
    (location) =>
      typeof location.distance === 'number' && location.distance <= radius
  );
};
